import dayjs from "dayjs";

import { toLocaleIsoString } from "@utils/time";
import { MM_DD_YYYY } from "@constants/dateTime";

import type { DateRange } from "rsuite/DateRangePicker";

export const today = dayjs().startOf("day").toISOString();
export const yesterday = dayjs()
  .subtract(1, "day")
  .startOf("day")
  .toISOString();
export const startOfWeek = dayjs().startOf("week").toISOString();
export const endOfWeek = dayjs().endOf("week").toISOString();

export const localeIsoDateRange = ([startDate, endDate]: DateRange) => {
  const start = toLocaleIsoString({
    isoDateString: startDate.toISOString(),
    format: MM_DD_YYYY,
  });

  const end = toLocaleIsoString({
    isoDateString: endDate.toISOString(),
    format: MM_DD_YYYY,
  });

  return `${start} - ${end}`;
};
